import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'tabs-tile',
  templateUrl: './tabs-tile.component.html',
  styleUrls: ['./tabs-tile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsTileComponent implements OnChanges {
  @Input() tabs: any;
  @Input() hasRouting: boolean = true;
  @Output() selectedTab = new EventEmitter<any>();

  tabsItems: any = [];
  copyTabs: any;

  click(tab, e: Event) {
    e.stopPropagation();
    e.preventDefault();

    this.tabs.selected = tab;
    this.selectedTab.next({ tab: tab });
    this._cdr.detectChanges();
    return tab.click ? tab.click() : null;
  }

  getLink(tab) {
    if (tab.hasOwnProperty('linkParams')) {
      return tab.linkParams;
    }
    return tab.link ? tab.link : null;
  }

  getQueryParams(tab) {
    return tab.queryParams ? tab.queryParams : null;
  }

  isActive(tab) {
    return this.tabs.selected === tab;
  }

  isDisable(tab) {
    if (tab.hasOwnProperty('disable')) {
      return tab.disable;
    }

    return false;
  }

  private initTabs() {
    this.tabsItems = [];

    this.copyTabs = Object.assign({}, this.tabs);

    if (this.copyTabs.items.length) {
      this.copyTabs.items.forEach((item) => {
        if (item.hasOwnProperty('show')) {
          if (item.show) {
            this.tabsItems.push(item);
          }
        } else {
          this.tabsItems.push(item);
        }
      });
    }

    if (!this.tabs.selected) {
      this.tabs.selected = this.tabs.items[0];
    }

    return this.copyTabs;
  }

  ngOnChanges(): void {
    if (this.hasRouting) {
      this._route.queryParams.subscribe((params) => {
        if (this.tabs) {
          this.initTabs();
        }
      });
    } else {
      if (this.tabs) {
        this.initTabs();
      }
    }

    this.tabs.selectTab = (tab) => {
      this.tabs.selected = tab;
      this.selectedTab.next({ tab: tab });
      this._cdr.markForCheck();
    };
  }

  constructor(
    private _route: ActivatedRoute,
    private _cdr: ChangeDetectorRef
  ) {}
}
